import React, { useState } from 'react';
import Header from './../components/DailyOperation/Header/Header';
import SearchCondition from '../components/DailyOperation/Header/SearchCondition';
import FirstContainer from '../components/DailyOperation/Body/FirstContainer';
import SecondContainer from '../components/DailyOperation/Body/SecondContainer';
import FivthContainer from '../components/DailyOperation/Body/FivthContainer';
import FourthContainer from '../components/DailyOperation/Body/FourthContainer';
import LastContainer from '../components/DailyOperation/Body/LastContainer';
import OtherThird from '../components/DailyOperation/Body/OtherThird';
import { MOCK_DATAS } from './../components/DailyOperation/MockDatas/MockData';

const DailyOperation = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [data, setData] = useState([]);

  const handleDateChange = (date, isSearch) => {
    setSelectedDate(date);
    if (isSearch) {
      const formattedDate = date.toISOString().split('T')[0];

      // Filter data based on the selected date
      const filteredData = MOCK_DATAS.flatMap(machine => machine.data.filter(entry => entry.date === formattedDate));

      setData(filteredData);
    }
  };

  return (
    <div className='p-4'>
      <Header />
      <SearchCondition onDateChange={handleDateChange} />
      <FirstContainer data={data} />
      <SecondContainer data={data} />
      <OtherThird data={data} />
      <FourthContainer data={data} />
      <FivthContainer data={data} />
      <LastContainer data={data} />
    </div>
  );
};

export default DailyOperation;
